module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/YK4352_banner.a1a091d5.png";